export const linkTitles = {
  aboutUs: 'About Us',
  admins: 'Administrators',
  aiLab: 'AI Lab',
  aiTools: 'AI Tools',
  home: 'Home',
  login: 'Login',
  parents: 'Parents',
  students: 'Students',
  teachers: 'Teachers',
  termsConditions: 'Terms and Conditions',
};
export const rolesInEducation = {
  parents: linkTitles.parents,
  schools: linkTitles.admins,
  students: linkTitles.students,
  teachers: linkTitles.teachers,
};
export const routeKeys = {
  aboutUs: '/About-Us',
  contactUs: '/Contact-Us',
  aiLab: '/AI-Lab',
  aiTools: '/AI-Tools',
  home: '/',
  login: '/',
  parents: '/Parents',
  admins: '/Administrators',
  students: '/Students',
  services: '/Students',
  teachers: '/Teachers',
  termsConditions: '/Terms-and-Conditions',
};

export const routeKeyPath = {
  aiLab: '/ai-tools',
  contactUs: '/contact-us',
  forParents: '/for-parents',
  forLearners: '/for-students',
  forTeachers: '/for-teachers',
  services: '/services',
};
export const navTitles = {
  contactUs: 'Contact Us',
  aiLab: 'AI Tools',
  home: 'Home',
  forParents: 'For Parents/Guardians',
  forStudents: 'For Learners',
  forTeachers: 'For Teachers',
};
export const wcedSocialPagesLinks = {
  facebook: 'https://www.facebook.com/wcednews',
  x: 'https://x.com/WCEDnews?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor',
  linkedIn: 'https://www.linkedin.com/company/western-cape-education-department/posts/?feedView=all',
  instagram: 'https://www.instagram.com/wced_official/?hl=en',
};

export const pageTargets = {
  showcaseSchool: 'showcase-your-school',
  inspire: 'inspire-learner-leadership',
  howToUseAi: 'how-to-use-ai',
  careerPathways: 'personalise-career-pathways',
  unlock: 'how-to-use-ai',
  connect: 'connect',
  learn: 'learn',
  day: 'day-in-the-life',
  entrep: 'entrepreneurship-hub',
  howYouCanHelp: 'how-you-can-help',
};

export const homeQuickLinks = [
  {
    text: navTitles.forTeachers,
    path: routeKeyPath.forTeachers,
  },
  {
    text: navTitles.forStudents,
    path: routeKeyPath.forLearners,
  },
  {
    text: navTitles.aiLab,
    path: routeKeyPath.aiLab,
  },
];

export const forLearnersQuickLinks = [
  {
    text: 'Day in the Life',
    path: `${routeKeyPath.forLearners}#${pageTargets.day}`,
    target: pageTargets.day,
  },
  {
    text: 'Entrepreneurship Hub',
    path: `${routeKeyPath.forLearners}#${pageTargets.entrep}`,
    target: pageTargets.entrep,
  },
];

export const exploreLinks = [
  {
    text: linkTitles.aboutUs,
    path: routeKeys.aboutUs,
  },
  {
    text: linkTitles.aiLab,
    path: routeKeys.aiLab,
  },
  {
    text: linkTitles.aiTools,
    path: routeKeys.aiTools,
  },
  {
    text: linkTitles.login,
    path: routeKeys.login,
  },
];
export const quickLinks = [
  {
    text: linkTitles.admins,
    path: routeKeys.admins,
  },
  {
    text: linkTitles.teachers,
    path: routeKeys.teachers,
  },
  {
    text: linkTitles.parents,
    path: routeKeys.parents,
  },
  {
    text: linkTitles.students,
    path: routeKeys.students,
  },
];

export const btnSecondaryStyle = {
  bgcolor: 'secondary.main',
  color: 'common.white',
  '&:hover': {
    bgcolor: 'secondary.dark',
    color: 'primary.light',
    boxShadow: 'boxShadows.shadowPrimary',
  },
};

export const responsivePagePadding = {
  xs: '10px 20px',
  md: '40px 120px',
};

export const hulaLinks = {
  AI_LAB: 'https://www.ailab.hulatechnology.com/',
  hula: 'https://www.hulatechnology.com/',
  AI_LAB_TUTS:
    'https://www.youtube.com/watch?v=XU3z5vR2abc&list=PLQKeraWCAfmd1nQFeanCYiakaco5_QveK&ab_channel=HulaEducation',
};

export const aIToolsQuickLinks = [
  {
    text: 'AI Tutorials',
    path: hulaLinks.AI_LAB_TUTS,
  },
  {
    text: 'AI Lab',
    path: hulaLinks.AI_LAB,
  },
];

export const firebaseKeys = {
  EMAIL:'email',
  EMAIL_SUBS: 'emailSubscribers',
};
